import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getClinicProducts } from '../requests';

export const useClinicProducts = (clinicMasterProductId?: string) => {
  const isEnabled = Boolean(clinicMasterProductId);

  const { data, isLoading } = useQuery({
    queryFn: () => (clinicMasterProductId ? getClinicProducts(clinicMasterProductId) : null),
    queryKey: ['clinic-products', clinicMasterProductId],
    enabled: isEnabled
  });

  return {
    clinicProducts: data?.data.data || [],
    isLoading: isEnabled && isLoading,
    total: data?.data.pagination?.total
  };
};

export const useRemoveClinicProductsCache = () => {
  const queryClient = useQueryClient();

  return (masterProductId: string) => {
    queryClient.removeQueries({
      queryKey: ['clinic-products', masterProductId]
    });
  };
};
